import { faArrowsRotate, faCheck, faExclamation, faGear } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Accordion, Col, Row } from 'react-bootstrap'
import { ProfileVM } from '../../Structure/ViewModels/Trainee/ProfileVM'
import { useEffect, useState } from 'react'
import { SpecializationSubscription, SubscriptionData, TraineeSubscription } from '../../Structure/Models/Trainee'
import { SubscriptionCardVM } from '../../Structure/ViewModels/Trainee/SubscriptionCard'
import { Router } from '../../Structure/Handlers/Router'
import AddTransaction from './AddTransaction'
import CustomSelect from '../Utilities/CustomSelect'
import { CourseCertify } from '../../Structure/Models/Course'
import { Globals } from '../../Structure/Globals/GlobalObs'
import { GeneralMethods } from '../../Structure/Handlers/GeneralMethods'
import { bePath } from '../../Structure/Constants/MainPath'
import { Account } from '../../Structure/Models/Accounts'
import { Props } from 'react-select'
import EditClientSubscribe from '../Management/EditClientSubscribe'

const SubscriptionCard = (props:{data:SpecializationSubscription , id:string , name:string , accounts:Account[] ,vm:ProfileVM}) => {
    const [vm , setVm] = useState<{viewModel:SubscriptionCardVM}>({viewModel:new SubscriptionCardVM()})
    const control = vm.viewModel
    useEffect(()=>{ 
        control.subscribeUpdate(setVm) 
        control.setData(props.data)
    }, [])
  return (
    <div className='py-5'>
        {
        control.Show(
        <Row className='box-shadow-I py-3'>
        <div className='d-flex flex-wrap justify-content-between pb-5'>
            <div className='d-flex flex-wrap'>
                <h4 className='txt-color-I fw-bold'>
                     {control.Data?.specialization||''}
                </h4>
            </div>
        </div>
        {
            Globals.auth.User?.permissions.some(a=>a.id=='5')?(
                <div className='py-3'>
                    <h4 className='txt-color-I'>الحسابات</h4>
                    <div className='d-flex flex-column py-3'>
                        <Accordion defaultActiveKey="0" className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                        {
                        control.Data?.levels.map((item,index)=>(
                            item.subscription?(
                                <Accordion.Item  key={index} eventKey={(index+1).toString()} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                                  <Accordion.Header className=' rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                                      <h5 className='px-3'>
                                           <span className='text-danger'>{item.subscription.code}</span> {item.level}
                                      </h5>
                                      <h5>
                                        <sub className='px-3 text-success'>
                                            {item.subscription.verification === 'verify'?' توثيق':''}
                                        </sub>
                                      </h5>
                                      <h5 className='px-3'>
                                            <sub className='px-1 material-symbols-outlined ' onClick={()=>Router.OpenNormalPage(<EditClientSubscribe id={props.id} subs={item} subName={item.level + ' ' + (control.Data?.specialization)} name={props.name}/>)}>
                                                edit
                                            </sub>
                                        </h5>
                                      {
                                        item.subscription.transactions.length == 0?(<>

                                        <h5 className='px-3'>
                                            <sub className='px-1 material-symbols-outlined ' onClick={()=>props.vm.deleteSubscription(item.subscription.id)}>
                                                delete
                                            </sub>
                                        </h5>
                                    </>):null
                                      }

                                  </Accordion.Header>
                                  <Accordion.Body className=' overflow-x-auto'>
                                    <div className='d-flex flex-wrap justify-content-around py-3 text-center'>
                                        <h6 className='py-2 mx-auto' style={{minWidth:'200px'}}>
                                            المطلوب سداده : {Math.max(Number(item.subscription.price)-Number(item.subscription.discount),0)}
                                        </h6>
                                        <h6 className='py-2 mx-auto' style={{minWidth:'200px'}}>
                                            اجمالى المدفوع : {item.subscription.paid}
                                        </h6>
                                        <h6 className='py-2 mx-auto' style={{minWidth:'200px'}}>
                                            المتبقي : {Math.max(Number(item.subscription.price)-Number(item.subscription.discount)-Number(item.subscription.paid),0) }
                                        </h6>
                                        {
                                            Globals.auth.User?.permissions.some(a=>a.id=='4')?(
                                                <h6 className='py-1 px-3 mx-auto material-symbols-outlined button-II btn-cl-I text-white c-pointer' onClick={()=>Router.OpenNormalPage(<AddTransaction subscription={item} id={props.id} name={props.name} />)}>
                                                    add
                                                </h6>
                                            ):(null)
                                        }
                                    </div>
                                  <table className='w-100 text-center' style={{minWidth:'1000px'}}>
                                      <tr className='txt-color-I bg-light-gray'>
                                          <th>id</th>
                                          <th>المسوق</th>
                                          <th>المدفوع</th>
                                          <th>سعر العملة</th>
                                          <th>القيمة</th>
                                          <th>نوع الحساب</th>
                                          <th>تاريخ التحويل</th>
                                          <th>صورة الايصال</th>
                                          <th>مدفوعات اضافية</th>
                                          <th>ملاحظات</th>
                                          <th></th>
                                      </tr>
                                      {
                                        item.subscription.transactions.map((trans,ind)=>
                                            {
                                                const Itemm = ()=>{
                                                    const [avail, setAvail] = useState(true)
                                                    const [deleting, setDeleting] = useState(false)
                                                    const [isInitialized, setIsInitialized] = useState(false);
                                                    const [edit, setEdit] = useState(false)
                                                    const [value, setValue] = useState(trans.value)
                                                    const [currencyPrice, setCurrencyPrice] = useState(trans.currency_price)
                                                    const [accountId, setAccountId] = useState(trans.account_id)
                                                    const [date, setDate] = useState(trans.date)
                                                    const [img, setImg] = useState<File|null|string>(trans.img_path)
                                                    const [additional, setAdditional] = useState(trans.additional)
                                                    const [notes, setNotes] = useState(trans.notes)

                                                    useEffect(()=>{
                                                        if(isInitialized){
                                                            setCurrencyPrice(props.accounts.find(a=>a.id===accountId)?.currency?.price??currencyPrice)
                                                        }
                                                        else setIsInitialized(true)
                                                    },[accountId])

                                                    const Img = ()=>{
                                                        const type = GeneralMethods.isImageOrPdf(trans.img_path)
                                                        if(img === null) return(<td></td>)
                                                        if(type){
                                                            if(type === 'pdf')return(<td onClick={()=>window.open(`${bePath}/storage/uploads/images/transactions/${trans.img_path}`)}>مشاهدة الملف</td>)
                                                            else if(type=== 'img')return(
                                                                <td onClick={()=>window.open(`${bePath}/storage/uploads/images/transactions/${trans.img_path}`)}>
                                                                    <img style={{height:'50px' , maxWidth:'100px'}} src={img instanceof File?URL.createObjectURL(img):`${bePath}/storage/uploads/images/transactions/${trans.img_path}`} alt="" />
                                                                </td>
                                                            )
                                                            else return (<td></td>)
                                                        } else return (<td></td>)
                                                    }

                                                    return avail?(deleting?(
                                                        <div className='d-flex justify-content-between w-100'>
                                                            <h5>هل تريد حذف المعاملة المالة ؟</h5>
                                                            <div className=' d-flex justify-content-center'>
                                                                <div className='material-symbols-outlined text-success my-auto c-pointer px-2' onClick={()=>{
                                                                    control.deleteTransaction(trans.id, ()=>setAvail(true), item.subscription.transactions.length == 1?props.vm:undefined)
                                                                    setDeleting(false)
                                                                    setAvail(false)
                                                                }}>check</div>
                                                                <div className='material-symbols-outlined text-danger my-auto c-pointer px-2' onClick={()=>setDeleting(false)}>close</div>
                                                            </div>
                                                        </div>
                                                    ):(
                                                        <tr key={index} style={{background:ind%2?'white':'rgba(200,200,200,0.2)'}}>
                                                            <td>{trans.id}</td>
                                                            <td>{trans.marketer}</td>
                                                            <td>
                                                            {
                                                                edit?(
                                                                    <input type="text" className='input-field' style={{ width:'70px' }} value={value} onChange={a=>setValue(a.target.value)} />
                                                                ):(value)
                                                            }
                                                            </td>
                                                            <td>
                                                            {
                                                                edit?(
                                                                    <input type="text" className='input-field' style={{ width:'70px' }} value={currencyPrice} onChange={a=>setCurrencyPrice(a.target.value)} />
                                                                ):(currencyPrice)
                                                            }
                                                            </td>
                                                            <td>
                                                                {currencyPrice?Math.ceil((Number(value)/Number(currencyPrice))*100)/100:0}
                                                            </td>
                                                            <td>
                                                            {
                                                                edit?(
                                                                    <CustomSelect
                                                                        clearable={false}
                                                                        list={props.accounts.map(a=>({label:a.name , value:a.id}))}
                                                                        selected={accountId}
                                                                        onSelect={a=>setAccountId(a)}
                                                                    ></CustomSelect>
                                                                ):(
                                                                    props.accounts.find(a=>a.id === accountId)?.name
                                                                )
                                                            }
                                                            </td>
                                                            <td>
                                                            {
                                                                edit?
                                                                (
                                                                    <input type="date" className='input-field' style={{ width:'150px' }} value={date} onChange={a=>setDate(a.target.value)} />
                                                                ):(date)    
                                                            }
                                                            </td>
                                                            <td>
                                                            {
                                                                edit?(
                                                                    <input type="file" accept="image/*,application/pdf" style={{ width:'100px' }} onChange={a=>setImg(a.target.files?a.target.files[0]:img)} />
                                                                ):(<Img/>)
                                                            }
                                                            </td>
                                                            <td>
                                                            {
                                                                edit?
                                                                (
                                                                    <input type="text" className='input-field' style={{ width:'150px' }} value={additional} onChange={a=>setAdditional(a.target.value)} />
                                                                ):(additional)    
                                                            }
                                                            </td>
                                                            <td>
                                                            {
                                                                edit?
                                                                (
                                                                    <input type="text" className='input-field' style={{ width:'150px' }} value={notes} onChange={a=>setNotes(a.target.value)} />
                                                                ):(notes)    
                                                            }
                                                            </td>
                                                            <td>
                                                                {
                                                                    trans.is_done!='done'?(    
                                                                    <div className='d-flex my-auto'>
                                                                        {
                                                                            edit?(
                                                                                <div className='material-symbols-outlined success-item my-auto c-pointer px-2' onClick={()=>{
                                                                                    control.editTransaction(trans.id ,accountId , value , currencyPrice  , date , img , additional , notes , ()=>{
                                                                                        setValue(trans.value)
                                                                                        setCurrencyPrice(trans.currency_price)
                                                                                        setAccountId(trans.account_id)
                                                                                        setDate(trans.date)
                                                                                        setImg(trans.img_path)
                                                                                        setAdditional(trans.additional)
                                                                                        setNotes(trans.notes)
                                                                                    })
                                                                                    setEdit(false)
                                                                                }}>save</div>
                                                                            ):(null)
                                                                        }
                                                                        {
                                                                            edit?(
                                                                                <div className='material-symbols-outlined danger-item my-auto c-pointer px-2' onClick={()=>{
                                                                                    setValue(trans.value)
                                                                                    setCurrencyPrice(trans.currency_price)
                                                                                    setAccountId(trans.account_id)
                                                                                    setDate(trans.date)
                                                                                    setImg(trans.img_path)
                                                                                    setAdditional(trans.additional)
                                                                                    setNotes(trans.notes)
                                                                                    setEdit(false)
                                                                                }}>close</div>
                                                                            ):(null)
                                                                        }
                                                                        {
                                                                            edit?(null):(
                                                                                <div className='material-symbols-outlined success-item my-auto c-pointer px-2' onClick={()=>setEdit(true)}>edit</div>
                                                                            )
                                                                        }
                                                                        <div className='material-symbols-outlined danger-item my-auto c-pointer px-2' onClick={()=>setDeleting(true)}>delete</div>
                                                                    </div>):(null)
                                                                }
                                                            </td>
                                                        </tr>)
                                                    ):(null)
                                                }
                                                return(<Itemm />)
                                            }
                                        )
                                      }
                                  </table>
                                  </Accordion.Body>
                                </Accordion.Item>
                                ):(null)
                            ))
                        }
                        </Accordion>
                    </div>
                </div>
            ):(null)
        }
        <div className='py-3'>
            <h4 className='txt-color-I'>الكورسات</h4>
            <div className='d-flex flex-column py-3'>
                <Accordion defaultActiveKey="0" className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                {
                control.Data?.levels.map((item,index)=>(
                    item.subscription?(
                        <Accordion.Item  key={index} eventKey={(index+1).toString()} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                          <Accordion.Header className=' rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                              <h5 className='px-3'>
                                  {item.level}
                              </h5>
                              <h5>
                                <sub className='px-3 text-success'>
                                    {item.subscription.verification === 'verify'?' توثيق':''}
                                </sub>
                              </h5>
                          </Accordion.Header>
                          <Accordion.Body >
                          {
                            item.subscription.courses.length>0?item.subscription.courses.map((it , ind)=>{
                                const MycallBack = ()=>{
                                const [selected, setSelected] = useState<string>(it.current_period.id)
                                const [changed , setChanged] = useState<Boolean>(false)
                                return(
                                    Globals.auth.User?.permissions.some(a=>a.id=='23')?(
                                    <Row className='p-3' style={{background:ind%2?'white':'rgba(200,200,200,0.2)'}} >
                                        <Col md={4} className='my-auto d-flex justify-content-center  py-2'>
                                             <h5 className='my-auto'>{it.course}</h5>
                                        </Col>
                                        <Col md={4} className='my-auto d-flex justify-content-center  py-2'>
                                            <CustomSelect list={it?(it.periods?it.periods.map(i=>({label:'من '+i.start+' الى '+i.end , value:i.id})):[]):[]} selected={selected} onSelect={a=>setSelected(a)} />
                                        </Col>
                                        <Col md={4} className='my-auto d-flex justify-content-around  py-2'>
                                            {
                                                (selected === it.current_period.id)||changed?
                                                (
                                                    <div className='material-symbols-outlined fs-2' style={{color:'rgb(150,150,150)'}}>save</div>
                                                )
                                                :(
                                                    <div className='material-symbols-outlined text-success c-pointer fs-2' onClick={()=>{ if( control.Data ){control.changePeriod(it.id , selected , item.subscription.id , props.id);setChanged(true)} }}>save</div>
                                                )
                                            }
                                            <div className='material-symbols-outlined text-success c-pointer fs-2' onClick={()=>{ if(control.Data) control.certifyCourse( props.id, it.id , item.subscription.level_specialization_id , selected ,  item.subscription.id ,item.id); }}>done_outline</div>

                                        </Col>
                                    </Row>
                                    ):(
                                        <Row className='p-3' style={{background:ind%2?'white':'rgba(200,200,200,0.2)'}} >
                                        <Col md={4} className='my-auto d-flex justify-content-center py-2'>
                                             <h5 className='my-auto'>{it.course}</h5>
                                        </Col>
                                        <Col md={4} className='my-auto d-flex justify-content-center  py-2'>
                                            <h5 className='my-auto'>{it?(it.current_period?('من '+(it.current_period.start||'ـــ')+' الى '+(it.current_period.end||'ـــ')):(null)):(null)}</h5>
                                        </Col>
                                    </Row>
                                    )
                                )}  
                                return(<MycallBack  key={index}/>)
                            }):(null)
                          }
                          </Accordion.Body>
                        </Accordion.Item>
                        ):(null)
                    ))
                }
                </Accordion>
            </div>
        </div>
        </Row>)
        }
    </div>
  )
}

export default SubscriptionCard
